import { render, staticRenderFns } from "./gc-popup-reorder-layout.vue?vue&type=template&id=172a1e5d"
import script from "./gc-popup-reorder-layout.vue?vue&type=script&lang=js"
export * from "./gc-popup-reorder-layout.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-reorder-layout.vue?vue&type=style&index=0&id=172a1e5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports